<template>
  <v-menu v-if="versions" offset-y transition="slide-y-transition">
    <template v-slot:activator="{ on, attrs }">
      <button v-bind="attrs" class="no-outline flex-centering" v-on="on">
        <Button type="borderless" color="neutral" size="small">
          <Badge color="dark-grey"> {{ $t('v.') }}{{ selectedVersion.name }} </Badge>
          <VersionSelectorBadges :selected-version="selectedVersion" />
          <VersionDescription :version="selectedVersion" light-color class="ml-4" />
          <ChevronIcon class="chevron-icon" />
        </Button>
      </button>
    </template>
    <div class="dropdown-body dropdown-body_version-selector incoming-tender-version-selector-menu">
      <VersionSelectorMenuElement
        v-for="version in versions"
        :key="version.id"
        @click.native="changeSelectedVersion(version.id)"
      >
        <template #title> {{ $t('Offer') }} {{ $t('v.') }}{{ version.name }} </template>
        <template #badges>
          <VersionSelectorBadges :selected-version="version" />
        </template>
        <template #description>
          <VersionDescription :version="version" />
        </template>
        <template
          v-if="version.status === TENDER_OFFER_VERSION_STATUSSES.draft && !lastVersionIsDraft"
          #delete-icon
        >
          <DeleteIcon
            width="20"
            @click.stop="openDeleteOfferPopup({ id: version.id, isDelete: true })"
          />
        </template>
      </VersionSelectorMenuElement>
      <div v-if="versionCanBeAdded" class="d-contents">
        <div class="dropdown-divider" />
        <v-menu offset-x open-on-hover transition="slide-x-reverse-transition">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <DropdownMenuElement nested>
                {{ $t('Add new offer') }}
                <template slot="icon">
                  <PlusIcon />
                </template>
              </DropdownMenuElement>
            </div>
          </template>
          <div class="dropdown-body dropdown-body_version-selector">
            <VersionSelectorMenuElement @click.native="addNewVersionManually">
              <template #title>
                {{ $t('Add manually') }}
              </template>
              <template #description>
                {{ $t('Fill in all position inside Fixtender interface') }}
              </template>
            </VersionSelectorMenuElement>
            <VersionSelectorMenuElement>
              <template #title>
                {{ $t('Upload template file') }}
              </template>
              <template #description>
                {{ $t('Download template then upload to create offer') }}
              </template>
            </VersionSelectorMenuElement>
            <div class="dropdown-divider" />
            <VersionSelectorMenuElement>
              <ExcelTemplate
                :icon-size="26"
                :text="$t('Download bill of quantities')"
                class="fs-16"
                :incoming-tender-id="incomingTenderInfo.id"
              />
            </VersionSelectorMenuElement>
          </div>
        </v-menu>
      </div>
    </div>
  </v-menu>
</template>

<script>
  import { VMenu } from 'vuetify/lib';
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';
  import Button from '@/components/ui/Button';
  import ChevronIcon from '@/assets/icons/chevron-down.svg';
  import PlusIcon from '@/assets/icons/plus.svg';
  import VersionSelectorMenuElement from '@/components/incoming-tender/version-selector/VersionSelectorMenuElement';
  import ExcelTemplate from '@/components/tender/ExcelTemplate';
  import { mapActions, mapGetters, mapState } from 'vuex';
  import router from '@/router';
  import DeleteIcon from '@/assets/icons/trash.svg';
  import DeleteOfferConfirm from '@/components/incoming-tender/modals/DeleteOfferConfirm';
  import Badge from '@/components/ui/Badge';
  import VersionSelectorBadges from '@/components/incoming-tender/version-selector/VersionSelectorBadges';
  import VersionDescription from '@/components/incoming-tender/version-selector/VersionDescription';
  import TENDER_OFFER_VERSION_STATUSSES from '@/utils/constants/tender-offer-version-statuses';

  export default {
    name: 'IncomingTenderVersionSelector',
    components: {
      VersionDescription,
      VersionSelectorBadges,
      Badge,
      VersionSelectorMenuElement,
      VMenu,
      Button,
      ChevronIcon,
      PlusIcon,
      DropdownMenuElement,
      ExcelTemplate,
      DeleteIcon,
    },
    data() {
      return { TENDER_OFFER_VERSION_STATUSSES };
    },
    computed: {
      ...mapState({
        versions: (state) => state.incomingTender.incomingTenderVersions,
        incomingTenderInfo: (state) => state.incomingTender.incomingTenderInfo,
      }),
      ...mapGetters('incomingTender', [
        'versionCanBeAdded',
        'lastVersionIsDraft',
        'selectedVersion',
      ]),
    },
    methods: {
      ...mapActions('incomingTender', ['changeSelectedVersion', 'createIncomingTenderVersion']),
      ...mapActions('modal', ['openModal']),
      async addNewVersionManually() {
        await this.createIncomingTenderVersion(this.incomingTenderInfo.id);
        await router.push({ name: 'incoming-tender-offers' });
      },
      openDeleteOfferPopup({ id, isDelete }) {
        this.openModal({
          component: DeleteOfferConfirm,
          context: {
            tenderVersionId: id,
            isDelete,
          },
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .incoming-tender-version-selector-menu {
    max-height: 90vh;
    overflow: auto;
  }

  .chevron-icon {
    width: 16px;
    height: 16px;
    margin-right: -5px;
    margin-left: 4px;
  }
</style>
